import { QUERY_KEYS_SERVICE_AGREEMENTS } from 'api/query-keys';
import { serviceAgreementsService } from 'ogp/services';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { useAlert } from 'shared/components/alerts/use-alert';

export const useServiceAgreementActions = (serviceAgreementId: string) => {
  const { t } = useTranslation('ogp-screen-specific');
  const queryClient = useQueryClient();
  const { alertSuccess, alertError } = useAlert();

  const acceptMutationFn = async () => {
    await serviceAgreementsService.acceptServiceAgreement(serviceAgreementId);
  };
  const { mutate: acceptServiceAgreement } = useMutation(acceptMutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS_SERVICE_AGREEMENTS.detail(serviceAgreementId));
      alertSuccess(t('collegial_lending_page.service-agreement.accepted'));
    },
    onError: (e) => {
      alertError(e);
    },
  });

  const rejectMutationFn = async () => {
    await serviceAgreementsService.rejectServiceAgreement(serviceAgreementId);
  };
  const { mutate: rejectServiceAgreement } = useMutation(rejectMutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS_SERVICE_AGREEMENTS.detail(serviceAgreementId));
      alertSuccess(t('collegial_lending_page.service-agreement.rejected'));
    },
    onError: (e) => {
      alertError(e);
    },
  });

  return { acceptServiceAgreement, rejectServiceAgreement };
};
